/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { notificationEmailSettingsControllerGetNotificationEmailSettings } from "./notificationEmailSettingsControllerGetNotificationEmailSettings";
import { notificationEmailSettingsControllerUpdateNotificationEmailSettings } from "./notificationEmailSettingsControllerUpdateNotificationEmailSettings";

export function notificationEmailSettingsService() {
  return { notificationEmailSettingsControllerGetNotificationEmailSettings, notificationEmailSettingsControllerUpdateNotificationEmailSettings }
}